import { configureStore } from '@reduxjs/toolkit';

import { createReducers } from 'REDUCERS';
import { createMiddlewares } from './middlewares';
import { initialState as appInitialState } from 'REDUCERS/appSlice';
import { buildCheckList } from 'CHECKS';

export let store;
export let checkList = [];
export const initializeStore = ({
  verbose = false,
  backUrl,
  closeOnBack = false,
  relayServers,
  supportPhoneNumber,
  checkToRunList,
}) => {
  checkList = buildCheckList(checkToRunList);
  const reducer = createReducers({ checkList });
  const middleware = createMiddlewares({ verbose, checkList });
  let cleanBackUrl = null;
  try {
    cleanBackUrl = new URL(backUrl);
  } catch (err) {
    if (err.name !== 'TypeError') {
      throw err;
    }
  }
  store = configureStore({
    reducer,
    middleware,
    preloadedState: {
      app: {
        ...appInitialState,
        relayServers,
        isVerbose: verbose,
        backUrl: cleanBackUrl?.href,
        closeOnBack,
        supportPhoneNumber,
      },
    },
  });
};
